import en from 'vuetify/src/locale/en.ts'

export default {
    $vuetify: {
        ...en,
        auth: {
            login: {
                formTitle: 'Login',
                userName: 'UserName',
                password: 'Password',
                loginBtn: 'Login'
            }
        },
        menu: {
            profile: 'Profile',
            logout: 'Logout',
            account: 'Account',
        }
    }
}